import { useEffect, useRef, useState } from 'react';
import { slideDown, slideUp } from '../animation/animation';


const ThemeSeven = ({ attributes, setAttributes }) => {

    const { faqData = [], faqIcon = {} } = attributes || {};

    const { open, close } = faqIcon;

    const [active, setActive] = useState(null);
    const refs = useRef([]);

    const toggleAccordion = (index) => {
        setActive(active === index ? null : index);
        setAttributes({ activeItem: index });
    };

    useEffect(() => {
        refs.current.forEach((el, i) => {
            if (!el) return;

            if (active === i) {
                slideDown(el, 700);
            } else {
                slideUp(el, 700);
            }
        });
    }, [active]);

    return (
        <div className="themeSevenWrapper faq-container-style">
            {faqData.map((item, index) => (
                <div key={index} className="faq-item"
                    onClick={() => setAttributes({ activeItem: index })}
                >
                    <div
                        className={`faq-question ${active === index ? "active" : ""}`}
                        onClick={() => toggleAccordion(index)}
                    >
                        <div className="faq-icon">
                            {active === index ? (
                                <span
                                    className="icon"
                                    dangerouslySetInnerHTML={{ __html: open }}
                                />
                            ) : (
                                <span
                                    className="icon"
                                    dangerouslySetInnerHTML={{ __html: close }}
                                />
                            )}
                        </div>
                        <div className="faq-question-title">
                            {item?.question}
                        </div>
                    </div>

                    <div
                        className="faq-answer"
                        ref={(el) => (refs.current[index] = el)}
                        style={{ overflow: "hidden", height: 0 }}
                    >
                        <p className="faq-answer-para">{item?.answer}</p>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default ThemeSeven;


